import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import AboutScreen from "./AboutScreen";
import ProposalScreen from "./ProposalScreen";
import DesignScreen from "./DesignScreen";
import FinalScreen from "./FinalScreen";

const App = () => {
  const [activeTab, setActiveTab] = React.useState("about");
  return (
    <div>
      <div>
        <Navbar bg="dark" variant="dark">
          <Container>
            <Navbar.Brand
              style={{ cursor: "pointer" }}
              onClick={() => setActiveTab("about")}
            >
              CS353 Term Project
            </Navbar.Brand>
            <Nav className="me-auto">
              <Nav.Link onClick={() => setActiveTab("about")}>About</Nav.Link>
              <Nav.Link onClick={() => setActiveTab("proposal")}>
                Proposal Report
              </Nav.Link>
              <Nav.Link onClick={() => setActiveTab("design")}>
                Design Report
              </Nav.Link>
              <Nav.Link onClick={() => setActiveTab("final")}>
                Final Report
              </Nav.Link>
            </Nav>
          </Container>
        </Navbar>
        <Container>
          {activeTab === "about" ? (
            <AboutScreen passChildData={setActiveTab} />
          ) : activeTab === "proposal" ? (
            <ProposalScreen />
          ) : activeTab === "design" ? (
            <DesignScreen />
          ) : activeTab === "final" ? (
            <FinalScreen />
          ) : null}
        </Container>
      </div>
    </div>
  );
};

export default App;
